import Breadcrumbs from '@/breadcrumbs'

const PageInfo = {
	computed: {
		pageName: function () {
			// Return the page name
			return this.$options.name
		},
		pageTitle: function () {
			// Return the page title
			if (this.pageByAccountType) {
				return this.$t('Page.Title.' + this.$options.name + (this.$store.getters.isUser ? 'User' : 'Lawyer'))
			}
			if (this.pageByCode) {
				return this.$t('Page.Title.' + this.$options.name + '.' + this.code)
			}

			if (this.pageWithMultipleTitle && this.$route.query.redirect_to === '/request/create/1') {
				// Register user hack
				return this.$t('Page.Title.' + this.$options.name + 'FindALawyer')
			}
			return this.$t('Page.Title.' + this.$options.name)
		},
		pageContent: function () {
			// Return the page content
			if (this.pageByAccountType) {
				return this.$t('Page.Content.' + this.$options.name + (this.$store.getters.isUser ? 'User' : 'Lawyer'))
			}
			if (this.pageByCode) {
				return this.$t('Page.Content.' + this.$options.name + '.' + this.code)
			}
			return this.$t('Page.Content.' + this.$options.name)
		},
		pageBreadcrumbs: function () {
			// Return the page breadcrumbs
			let pageBreadcrumbs
			if (this.pageByAccountType) {
				pageBreadcrumbs = Breadcrumbs[this.$options.name + (this.$store.getters.isUser ? 'User' : 'Lawyer')]
			} else if (this.pageByCode) {
				pageBreadcrumbs = Breadcrumbs[this.$options.name + '.' + this.code]
			} else if (this.pageWithMultipleTitle && this.$route.query.redirect_to === '/request/create/1') {
				// Register user hack
				pageBreadcrumbs = Breadcrumbs[this.$options.name + 'FindALawyer']
			} else {
				pageBreadcrumbs = Breadcrumbs[this.$options.name]
			}
			return pageBreadcrumbs ? pageBreadcrumbs : []
		},
		robotsRule: function () {
			// Return the page robots rule
			if (this.pageToNotIndexFromRobots) {
				return 'noindex'
			}
			return 'all'
		},
		seoTitle: function () {
			// Return the page SEO title
			if (this.pageByAccountType) {
				return this.$t('Seo.Title.' + this.$options.name + (this.$store.getters.isUser ? 'User' : 'Lawyer'))
			}
			if (this.pageByCode) {
				if (this.pageBySlug) {
					return this.$t('Seo.Title.' + this.$options.name + '.' + this.code + '.' + this.slug)
				} else {
					return this.$t('Seo.Title.' + this.$options.name + '.' + this.code)
				}
			}

			if (this.pageWithMultipleTitle && this.$route.query.redirect_to === '/request/create/1') {
				// Register user hack
				return this.$t('Seo.Title.' + this.$options.name + 'FindALawyer')
			}
			return this.$t('Seo.Title.' + this.$options.name)
		},
		seoDescription: function () {
			// Return the page SEO description
			if (this.pageByAccountType) {
				return this.$t('Seo.Description.' + this.$options.name + (this.$store.getters.isUser ? 'User' : 'Lawyer'))
			}
			if (this.pageByCode) {
				if (this.pageBySlug) {
					return this.$t('Seo.Description.' + this.$options.name + '.' + this.code + '.' + this.slug)
				} else {
					return this.$t('Seo.Description.' + this.$options.name + '.' + this.code)
				}
			}
			return this.$t('Seo.Description.' + this.$options.name)
		},
	},
	head: {
		title: function () {
			return {
				inner: this.seoTitle,
			}
		},
		meta: function () {
			return [
				{ name: 'description', id: 'desc', content: this.seoDescription },
				{ name: 'robots', content: this.robotsRule },
			]
		},
	},
	mounted() {
		// Re-apply custom JS
		this.$helpers.deleteScript('/static/js/custom.js')
		this.$helpers.addBodyScript('/static/js/custom.js')
	},
}

export default PageInfo



// WEBPACK FOOTER //
// ./src/mixins/PageInfo.js